<template>
  <div class="min-h-screen bg-gray-50 p-6">
    <div class="max-w-4xl mx-auto">
      <div class="bg-white rounded-lg shadow-md p-6 mb-6">
        <h1 class="text-2xl font-bold text-gray-900 mb-4">Simple Test Page</h1>
        
        <div class="mb-6">
          <h2 class="text-lg font-semibold text-gray-800 mb-3">Basic Test</h2>
          <p class="text-gray-600">If you can see this, the page is loading correctly.</p>
          <p class="text-gray-600">Status: {{ status }}</p>
        </div>

        <div class="mb-6">
          <h2 class="text-lg font-semibold text-gray-800 mb-3">AI Service Test</h2>
          <button 
            @click="testAIService"
            :disabled="isTesting"
            class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {{ isTesting ? 'Testing...' : 'Test AI Service' }}
          </button>
          <div v-if="aiTestResult" class="mt-4 p-4 bg-gray-50 rounded">
            <p class="text-gray-800">{{ aiTestResult }}</p>
          </div>
        </div>

        <div class="mb-6">
          <h2 class="text-lg font-semibold text-gray-800 mb-3">API Test</h2>
          <button 
            @click="testAPI"
            :disabled="isTestingAPI"
            class="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50"
          >
            {{ isTestingAPI ? 'Testing...' : 'Test API' }}
          </button>
          <div v-if="apiTestResult" class="mt-4 p-4 bg-gray-50 rounded">
            <p class="text-gray-800">{{ apiTestResult }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

// Reactive state
const status = ref('Loading...')
const isTesting = ref(false)
const isTestingAPI = ref(false)
const aiTestResult = ref('')
const apiTestResult = ref('')

// Test AI Service
const testAIService = async () => {
  isTesting.value = true
  aiTestResult.value = ''
  
  try {
    // Try to import AI service
    const { aiService } = await import('@/services/aiService')
    aiTestResult.value = 'AI Service imported successfully!'
    
    // Try to initialize
    await aiService.initialize()
    aiTestResult.value += ' AI Service initialized successfully!'
    
  } catch (error) {
    console.error('AI Service test failed:', error)
    aiTestResult.value = `Error: ${error.message}`
  } finally {
    isTesting.value = false
  }
}

// Test API
const testAPI = async () => {
  isTestingAPI.value = true
  apiTestResult.value = ''
  
  try {
    const response = await fetch('/api/test')
    const data = await response.json()
    apiTestResult.value = `API Test Result: ${JSON.stringify(data, null, 2)}`
  } catch (error) {
    console.error('API test failed:', error)
    apiTestResult.value = `API Error: ${error.message}`
  } finally {
    isTestingAPI.value = false
  }
}

// Initialize
onMounted(() => {
  status.value = 'Page loaded successfully!'
})
</script>
